import { Button } from "@mui/material";
import React from "react";
import { RegionSelector } from "../RegionSelector";
import TextFieldStyled from "../TextFieldStyled";
import { DevelopmentProgramCategorySelector } from "@/components/foerderung/DevelopmentProgramCategorySelector";
import { DevelopmentProgramFundingSelector } from "@/components/foerderung/DevelopmentProgramFundingSelector";
import { ZipcodeSelector } from "@/components/ZipcodeSelector";
import { DevelopmentProgramSortSelector } from "@/components/foerderung/DevelopmentProgramSortSelector";

export const FoerderfinderFilterContainer = ({
  filterMobile = false,
  handleInputChanged,
  handleFilterChanged,
  setSort,
  onCancel,
}) => {
  return (
    <>
      <TextFieldStyled
        label="Förderprogramme durchsuchen"
        name="filter"
        onChange={handleFilterChanged}
      />

      <DevelopmentProgramSortSelector setSort={setSort} />
      <DevelopmentProgramCategorySelector
        label="Art der Förderung"
        name="category"
        onChange={handleInputChanged}
      />
      <DevelopmentProgramFundingSelector
        label="Ausschreibende Fördereinrichtung"
        name="funding"
        onChange={handleInputChanged}
      />
      <RegionSelector
        label="Region"
        name="region"
        placeholder="Alle Regionen"
        onChange={handleInputChanged}
      />
      <ZipcodeSelector
        label="Förderprogramme in Deiner Region"
        name="zipcode"
        placeholder="PLZ eingeben"
        onChange={handleInputChanged}
      />

      {filterMobile && (
        <Button
          fullWidth
          color="secondary"
          variant="contained"
          onClick={onCancel}
        >
          Filter schließen
        </Button>
      )}
    </>
  );
};
